// extracted by mini-css-extract-plugin
export default {"blinkingCursor":"ChatPage_blinkingCursor__FILEF","blink":"ChatPage_blink__5lvZE"};